import * as userConstants from "@/core/models/usersAndPermissions";
import { routes } from "@/routing/routes";

const itemRefurbStepRouter = [
  {
    path: routes.searchItemRefurbSteps.path,
    name: routes.searchItemRefurbSteps.name,
    component: () =>
      import(
        /* webpackChunkName: "item-refurb-steps" */ "@/apps/dashboard/itemRefurbStep/view/pages/searchItemRefurbSteps/SearchItemRefurbStepsPage.vue"
      ),
  },
  {
    path: routes.item.path,
    redirect: { name: routes.itemRefurbSteps.name },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "item-refurb-steps" */ "@/apps/dashboard/itemRefurbStep/view/pages/itemRefurbStepsProcessing/ItemRefurbStepsPage.vue"
      ),
    meta: {
      permission: userConstants.ROLE_ITEM_REFURB_STEP_READ,
      routeKeyToPreventReloadMainLayout: "itemRefurbStep",
    },
    children: [
      {
        path: routes.itemRefurbSteps.path,
        name: routes.itemRefurbSteps.name,
        props: true,
        components: {
          [routes.itemRefurbSteps.name]: () =>
            import(
              /* webpackChunkName: "item-refurb-steps" */ "@/apps/dashboard/itemRefurbStep/view/pages/itemRefurbStepsProcessing/ItemRefurbStepsList.vue"
            ),
        },
        meta: {
          permission: userConstants.ROLE_ITEM_REFURB_STEP_READ,
          routeKeyToPreventReloadMainLayout: "itemRefurbStep",
        },
      },
      {
        path: routes.itemRefurbStep.path,
        name: routes.itemRefurbStep.name,
        props: { [routes.itemRefurbStep.name]: (route) => ({ itemRefurbStepId: route.params.itemRefurbStepId }) },
        components: {
          [routes.itemRefurbStep.name]: () =>
            import(
              /* webpackChunkName: "item-refurb-steps" */ "@/apps/dashboard/itemRefurbStep/view/pages/itemRefurbStepsProcessing/ItemRefurbStep.vue"
            ),
        },
        meta: {
          permission: userConstants.ROLE_ITEM_REFURB_STEP_READ,
          routeKeyToPreventReloadMainLayout: "itemRefurbStep",
        },
      },
    ],
  },
  {
    path: routes.itemRefurbStepsCompleted.path,
    name: routes.itemRefurbStepsCompleted.name,
    props: (route) => ({
      identificationNumber: route.query.identificationNumber,
      stockName: route.query.stockName,
    }),
    component: () =>
      import(
        /* webpackChunkName: "item-refurb-steps" */ "@/apps/dashboard/itemRefurbStep/view/pages/itemRefurbStepsCompleted/ItemRefurbStepsCompletedPage.vue"
      ),
    meta: {
      permission: userConstants.ROLE_ITEM_REFURB_STEP_READ,
    },
  },
];

export default itemRefurbStepRouter;
